import { ApiError } from "../../lib/api.js";

/**
 * What to tell an owner when a role write is refused (custom roles,
 * 2026-09-15). crm-api's codes are mapped to sentences a person can act on;
 * anything else falls back to the server's own message.
 */
export function roleErrorMessage(error: unknown, fallback = "We could not save the role. Try again."): string {
  if (!(error instanceof ApiError)) return fallback;
  switch (error.code) {
    case "ROLE_IN_USE": {
      const raw = error.details?.["member_count"];
      const count = typeof raw === "number" && raw > 0 ? raw : null;
      if (count === 1) return "1 person still has this role — move them to another role first.";
      if (count !== null) return `${count} people still have this role — move them to another role first.`;
      return "People still have this role — move them to another role first.";
    }
    case "ROLE_NAME_TAKEN":
      return "A role with that name already exists. Choose another name.";
    case "ROLE_NAME_INVALID":
      return error.message && !error.message.startsWith("The CRM refused")
        ? error.message
        : "That name cannot be used for a role.";
    case "ROLE_NOT_RENAMEABLE":
      return "Built-in roles cannot be renamed.";
    default:
      return error.message || fallback;
  }
}
